import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Web\ProductPage\ProductPageRecentProjectsController::__invoke
* @see Http/Controllers/Web/ProductPage/ProductPageRecentProjectsController.php:14
* @route '/product-page/{configurableProduct}/recent-projects'
*/
const ProductPageRecentProjectsController = (args: { configurableProduct: string | number | { url_key: string | number } } | [configurableProduct: string | number | { url_key: string | number } ] | string | number | { url_key: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: ProductPageRecentProjectsController.url(args, options),
    method: 'get',
})

ProductPageRecentProjectsController.definition = {
    methods: ["get","head"],
    url: '/product-page/{configurableProduct}/recent-projects',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Web\ProductPage\ProductPageRecentProjectsController::__invoke
* @see Http/Controllers/Web/ProductPage/ProductPageRecentProjectsController.php:14
* @route '/product-page/{configurableProduct}/recent-projects'
*/
ProductPageRecentProjectsController.url = (args: { configurableProduct: string | number | { url_key: string | number } } | [configurableProduct: string | number | { url_key: string | number } ] | string | number | { url_key: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { configurableProduct: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'url_key' in args) {
        args = { configurableProduct: args.url_key }
    }

    if (Array.isArray(args)) {
        args = {
            configurableProduct: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        configurableProduct: typeof args.configurableProduct === 'object'
        ? args.configurableProduct.url_key
        : args.configurableProduct,
    }

    return ProductPageRecentProjectsController.definition.url
            .replace('{configurableProduct}', parsedArgs.configurableProduct.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Web\ProductPage\ProductPageRecentProjectsController::__invoke
* @see Http/Controllers/Web/ProductPage/ProductPageRecentProjectsController.php:14
* @route '/product-page/{configurableProduct}/recent-projects'
*/
ProductPageRecentProjectsController.get = (args: { configurableProduct: string | number | { url_key: string | number } } | [configurableProduct: string | number | { url_key: string | number } ] | string | number | { url_key: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: ProductPageRecentProjectsController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Web\ProductPage\ProductPageRecentProjectsController::__invoke
* @see Http/Controllers/Web/ProductPage/ProductPageRecentProjectsController.php:14
* @route '/product-page/{configurableProduct}/recent-projects'
*/
ProductPageRecentProjectsController.head = (args: { configurableProduct: string | number | { url_key: string | number } } | [configurableProduct: string | number | { url_key: string | number } ] | string | number | { url_key: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: ProductPageRecentProjectsController.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Web\ProductPage\ProductPageRecentProjectsController::__invoke
* @see Http/Controllers/Web/ProductPage/ProductPageRecentProjectsController.php:14
* @route '/product-page/{configurableProduct}/recent-projects'
*/
const ProductPageRecentProjectsControllerForm = (args: { configurableProduct: string | number | { url_key: string | number } } | [configurableProduct: string | number | { url_key: string | number } ] | string | number | { url_key: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: ProductPageRecentProjectsController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Web\ProductPage\ProductPageRecentProjectsController::__invoke
* @see Http/Controllers/Web/ProductPage/ProductPageRecentProjectsController.php:14
* @route '/product-page/{configurableProduct}/recent-projects'
*/
ProductPageRecentProjectsControllerForm.get = (args: { configurableProduct: string | number | { url_key: string | number } } | [configurableProduct: string | number | { url_key: string | number } ] | string | number | { url_key: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: ProductPageRecentProjectsController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Web\ProductPage\ProductPageRecentProjectsController::__invoke
* @see Http/Controllers/Web/ProductPage/ProductPageRecentProjectsController.php:14
* @route '/product-page/{configurableProduct}/recent-projects'
*/
ProductPageRecentProjectsControllerForm.head = (args: { configurableProduct: string | number | { url_key: string | number } } | [configurableProduct: string | number | { url_key: string | number } ] | string | number | { url_key: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: ProductPageRecentProjectsController.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

ProductPageRecentProjectsController.form = ProductPageRecentProjectsControllerForm

export default ProductPageRecentProjectsController